import {useTranslation} from "react-i18next";

export default function ServiceItem({ service, handleClick }) {
    const { t } = useTranslation();

    return (
        <div
            className={`group mb-8 w-[125px] text-center hover:cursor-pointer lg:mb-4`}
            onClick={handleClick}
        >
            <div className="m-auto w-[100px] rounded-lg bg-gray-100 p-4 outline-offset-2 outline-orange-300 transition-colors group-hover:bg-orange-400 group-hover:outline">
                <img
                    src={"/assets/img/icons/services/g-" + service.icon + ".png"}
                    alt=""
                    className="m-auto h-16 w-16 group-hover:hidden"
                />
                <img
                    src={"/assets/img/icons/services/b-" + service.icon + ".png"}
                    alt=""
                    className="m-auto hidden h-16 w-16 group-hover:block"
                />
            </div>
            <h3 className="mt-2 font-medium text-gray-900 group-hover:text-orange-600">
                {t(service.title)}
            </h3>
        </div>
    );
}
